import api from './api';
import { IItemProperty, ItemAttribute } from '../store/types/ItemProperty';

const unitOfMeasurementPrefix: string = 'UOM_';
export async function getItems(searchItemRequest: any) {
  return await api.searchitems(searchItemRequest);
}

const mockCompanyList = [{ name: 'Square Enix', value: 1 },
{ name: 'Naughty Dog', value: 2 },
{ name: 'Insomniac', value: 3 },
{ name: 'Bioware', value: 4 },
{ name: 'Blizzard', value: 5 },
{ name: 'From Software', value: 6 },
{ name: 'Atlus', value: 7 },
{ name: 'Team Ninja', value: 8 }];

function mockCompany() {
  const numberOfCompanies: number = Math.floor(Math.random() * 9);
  return mockCompanyList.slice(0, numberOfCompanies);
}

function isNotUOM(attribute: string): boolean {
  return !attribute.startsWith(unitOfMeasurementPrefix);
}

const mapAttributes = (attributes: any[]): ItemAttribute[] => {
  return attributes
  .filter(isNotUOM)
  .map((attr: string) => {
    const attrSplited = attr.split('#');
    return {
      name: attrSplited[0],
      value: attrSplited[1],
      uid: attrSplited[0].split(' ').join('_'),
      UOM: attributes
        .filter(a => a.startsWith(`UOM_${attrSplited[0]}#`))
        .map(a => a.split('#')[1])[0],
      };
  }) ;
};

// valores atualizados: DocVer:"B". teste search: pilha alcalina
export function convertData(items: any): IItemProperty[] {
  return items.map((item: any) => {
    return {
      id: item.id,
      code: item.codigo,
      validName: item.nomeValido,
      name: item.nome,
      family: item.familia,
      statusERP: item.statusERP,
      unitOfMeasurement: item.unidadeMedida,
      itemCompanies: mockCompany(),
      productInformation: [
        {
          language: 'en',
          description: item['Descricao-en'],
          attributes: mapAttributes(item['Atributos-en']),
        },
        {
          language: 'pt',
          description: item['Descricao-pt'],
          attributes: mapAttributes(item['Atributos-pt']),
        },
        {
          language: 'es',
          description: item['Descricao-es'],
          attributes: mapAttributes(item['Atributos-es']),
        },
      ],
      itemManufacturers: item.partNumbers ?
        item.partNumbers.map((partNumber: string) => {
          const partNumberSplited = partNumber.split('#');
          return { name: partNumberSplited[0], value: partNumberSplited[1] };
        })
        : [],
    };
  });
}
